<template>
<v-container class="pt-0 px-0" fluid>
  <v-tabs v-model="displayedTab" background-color="integrity" dark show-arrows icons-and-text="" @change="tabChange">
    <v-tab v-for="(tab, idx) in tabConfig" :key="idx">
      {{ tab.title }}
      <v-icon>{{ tab.icon }}</v-icon>
    </v-tab>
  </v-tabs>
  <v-tabs-items v-model="displayedTab">
    <v-tab-item v-for="(tab, idx) in tabConfig" :key="idx">
      <component :is="tab.component" v-bind="tab.props" />
    </v-tab-item>
  </v-tabs-items>
</v-container>
</template>

<style>
</style>

<script>
import LineOfBusinessCoverages from '@/components/Client/LineOfBusiness/LineOfBusinessCoverages.vue';
import Vehicles from '@/components/Client/LineOfBusiness/Vehicles/Vehicles.vue';
import Drivers from '@/components/Client/LineOfBusiness/Drivers/Drivers.vue';
import Hazards from '@/components/Client/LineOfBusiness/Hazards/Hazards.vue';
import Schedules from '@/components/Client/LineOfBusiness/Schedules/Schedules.vue';

import { mapActions, mapState } from 'vuex';

import lobCodeService from '@/services/clientViewer/lobCodeService.js';
import analyticsService from '@/services/shared/analyticsService.js';

export default {
  name: 'LineOfBusinessViewTabs',
  components: {
    LineOfBusinessCoverages,
    Vehicles,
    Drivers,
    Hazards,
    Schedules
  },
  props: {
    lob: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      style: {
        'background-color': this.$vuetify.theme.themes.light.integrity,
        color: 'white'
      }
    };
  },
  computed: {
    ...mapState(['activeLineOfBusinessTab', 'selectedLineOfBusinessCode']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    lobCode: function () {
      return this.selectedLineOfBusinessCode;
    },
    displayedTab: {
      get: function () {
        return this.activeLineOfBusinessTab;
      },
      set: function (val) {
        this.setActiveLineOfBusinessTab(val);
      }
    },
    shouldDisplayHazards: function () {
      return lobCodeService.hazardCodes.includes(parseInt(this.lobCode));
    },
    shouldDisplayVehicles: function () {
      return lobCodeService.vehicleCodes.includes(parseInt(this.lobCode));
    },
    shouldDisplaySchedules: function () {
      return lobCodeService.scheduleCodes.includes(parseInt(this.lobCode));
    },
    tabConfig: function () {
      var tabs = [
        {
          title: 'Coverages',
          icon: 'mdi-shield-half-full',
          component: 'LineOfBusinessCoverages',
          gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'Line of Business Coverages' }
        }
      ];

      if (lobCodeService.hazardCodes.includes(parseInt(this.lobCode))) {
        tabs.push({
          title: 'Hazards',
          icon: 'mdi-hazard-lights',
          component: 'Hazards',
          gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: lobCodeService.containsWorkHazards(parseInt(this.lobCode)) ? 'Work Hazards Tab' : 'GL Hazards Tab' }
        });
      }

      if (lobCodeService.scheduleCodes.includes(parseInt(this.lobCode))) {
        tabs.push({
          title: 'Scheduled',
          icon: 'mdi-format-list-numbered',
          component: 'Schedules',
          props: { scheduleType: 1 },
          gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'Policy Scheduled Property' }
        });

        tabs.push({
          title: 'Unscheduled',
          icon: 'mdi-format-list-bulleted',
          component: 'Schedules',
          props: { scheduleType: 2 },
          gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'Policy Unscheduled Property' }
        });
      }

      return tabs;
    }
  },
  methods: {
    ...mapActions(['setActiveLineOfBusinessTab']),
    tabChange: function (value) {
      var tab = this.tabConfig[value];
      if ((tab || null) !== null) {
        analyticsService.sendEvent(this.$gtag, tab.gtagConfig.action, tab.gtagConfig.category, tab.gtagConfig.label);
      }
    }
  }
};
</script>
